import React from 'react';

import type { CampaignWithSubcampaignMeta } from 'types';

import { getDisplayDate } from 'utils/date';

type Props = {
  campaign: CampaignWithSubcampaignMeta
};

const CampaignsTableDateCell = ({
  campaign
}: Props) => (
  <div>
    {`${getDisplayDate(campaign.startDate)} - ${getDisplayDate(campaign.endDate)}`}
  </div>
);

export default CampaignsTableDateCell;
